import { blobticService } from '../../Commun/services/blobticService';

export enum WindowType {
    Casement = 1,
    TiltTurn = 2,
    Sliding = 3,
    French = 4,
    Italian = 5,
    Awning = 6,
    ParallelSliding = 7,
    Pivot = 8,
    Accordion = 9,
    LiftSliding = 10,
}

export enum ShapeType {
    Rectangular = 1,
    Round = 2,
    Trapezoid = 3,
    Custom = 4,
}

export enum MaterialType {
    Aluminum = 1,
    PVC = 2,
    Wood = 3,
    Steel = 4,
    Hybrid = 5,
}

export interface WindowDto {
    WIN_IDF: number;
    PRJ_IDF: number;
    WIN_TYPE: number;
    WIN_SHAPE: number;
    WIN_WIDTH: number;
    WIN_HEIGHT: number;
    WIN_MATERIAL_TYPE: number;
    PRF_IDF?: number;
    WIN_DATA?: string;
    LAST_UPDT?: string;
}

export interface Window {
    id: number;
    projectId: number;
    windowType: WindowType;
    shapeType: ShapeType;
    width: number;
    height: number;
    materialType: MaterialType;
    profileId?: number;
    customShapeData?: string;
    createdDate: string;
    modifiedDate?: string;
}

const mapDtoToModel = (dto: WindowDto): Window => ({
    id: dto.WIN_IDF,
    projectId: dto.PRJ_IDF,
    windowType: dto.WIN_TYPE,
    shapeType: dto.WIN_SHAPE,
    width: dto.WIN_WIDTH,
    height: dto.WIN_HEIGHT,
    materialType: dto.WIN_MATERIAL_TYPE,
    profileId: dto.PRF_IDF,
    customShapeData: dto.WIN_DATA,
    createdDate: dto.LAST_UPDT || new Date().toISOString(),
    modifiedDate: dto.LAST_UPDT
});

const mapModelToDto = (model: Partial<Window>): Partial<WindowDto> => ({
    WIN_IDF: model.id,
    PRJ_IDF: model.projectId,
    WIN_TYPE: model.windowType,
    WIN_SHAPE: model.shapeType,
    WIN_WIDTH: model.width,
    WIN_HEIGHT: model.height,
    WIN_MATERIAL_TYPE: model.materialType,
    PRF_IDF: model.profileId,
    WIN_DATA: model.customShapeData
});

export const windowsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest<WindowDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: { OKey: 'Blobtic_Maker,maker_window,Select' }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getByProject: async (projectId: number) => {
        const response = await blobticService.executeZoomRequest<WindowDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_window,Select',
                PRJ_IDF: projectId
            }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getById: async (id: number) => {
        const response = await blobticService.executeZoomRequest<WindowDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_window,Select',
                WIN_IDF: id
            }
        });
        const dto = response.data?.[0];
        return {
            data: dto ? mapDtoToModel(dto) : null,
            message: response.message
        };
    },

    create: async (window: Partial<Window>) => {
        const dto = mapModelToDto(window);
        const response = await blobticService.executeZoomRequest<WindowDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_window,Insert',
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    update: async (id: number, window: Partial<Window>) => {
        const dto = mapModelToDto(window);
        const response = await blobticService.executeZoomRequest<WindowDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_window,Update',
                WIN_IDF: id,
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_window,Delete',
                WIN_IDF: id
            }
        });
        return {
            success: true,
            message: response.message
        };
    }
};
